import { render, staticRenderFns } from "./addAcquisition.vue?vue&type=template&id=03074110&scoped=true&"
import script from "./addAcquisition.vue?vue&type=script&lang=js&"
export * from "./addAcquisition.vue?vue&type=script&lang=js&"
import style0 from "./addAcquisition.vue?vue&type=style&index=0&id=03074110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03074110",
  null
  
)

export default component.exports